import { render, staticRenderFns } from "./CargoProductList.vue?vue&type=template&id=2563cbd1&"
import script from "./CargoProductList.vue?vue&type=script&lang=js&"
export * from "./CargoProductList.vue?vue&type=script&lang=js&"
import style0 from "./CargoProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoProductList.vue"
export default component.exports